import { createInjectionKey as e } from "./ghl-ui.es927.js";
const i = e("n-time-picker");
export {
  i as timePickerInjectionKey
};
